export const TypeFilter = Object.freeze({
    User: "User",
    System: "System"
});

export const TypeFilterOptions = Object.values(TypeFilter);

export const DueStatus = Object.freeze({
    Pending: "Pending",
    Due: "Due",
    Overdue: "Overdue",
});

export const DueStatusOptions = Object.freeze(
    [
        {name: "Pending", code: "pending"},
        {name: "Due", code: "due"},
        {name: "Overdue", code: "overdue"},
    ]
)